import React from 'react';
import { ArrowRight, Plus, Minus, AlertCircle, Lightbulb } from 'lucide-react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Accordion } from '../components/ui/Accordion';
interface InterpretationDetailPageProps {
  onNavigate: (page: string) => void;
}
export function InterpretationDetailPage({
  onNavigate
}: InterpretationDetailPageProps) {
  const faqs = [{
    id: '1',
    title: 'Как проработать Марс в 7 доме?',
    content: 'Занимайтесь совместным спортом с партнером, открыто обсуждайте конфликты, не копите агрессию. Полезно иметь общие активные цели.'
  }, {
    id: '2',
    title: 'Означает ли это обязательный развод?',
    content: 'Нет. Это означает высокую динамику в отношениях. Если энергия Марса направлена в конструктивное русло (общие дела, бизнес, спорт), брак может быть очень крепким.'
  }];
  return <div className="w-full bg-slate-50 pb-24" data-id="element-20509">
      <div className="bg-white border-b border-slate-200 pt-8 pb-12" data-id="element-20510">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20511">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Трактовки',
          onClick: () => onNavigate('interpretations')
        }, {
          label: 'Планеты в домах',
          onClick: () => onNavigate('interpretations')
        }, {
          label: 'Марс в 7 доме'
        }]} className="mb-8" data-id="element-20512" />
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-20513">
            Марс в 7 доме
          </h1>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-20514">
            Положение, указывающее на высокую активность, страсть и возможные
            конфликты в сфере партнерства и брака.
          </p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-20515">
        <div className="prose prose-slate prose-lg max-w-none" data-id="element-20516">
          <p data-id="element-20517">
            Седьмой дом отвечает за брак, открытых врагов и деловое партнерство.
            Марс — планета энергии, агрессии, инициативы и страсти. Когда Марс
            попадает в 7 дом, сфера отношений становится полем боя или ареной
            для активных совместных действий.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-10 not-prose" data-id="element-20518">
            <Card padding="lg" className="border-emerald-200 bg-emerald-50/50" data-id="element-20519">
              <div className="flex items-center mb-4 text-emerald-700" data-id="element-20520">
                <Plus className="w-6 h-6 mr-2" data-id="element-20521" />
                <h3 className="text-lg font-bold" data-id="element-20522">В плюсе (Гармоничный)</h3>
              </div>
              <ul className="space-y-3 text-emerald-900 text-sm" data-id="element-20523">
                <li data-id="element-20524">• Страстные и яркие отношения</li>
                <li data-id="element-20525">• Партнер — активный, смелый, инициативный</li>
                <li data-id="element-20526">• Умение вместе преодолевать трудности</li>
                <li data-id="element-20527">• Успешное деловое партнерство, если есть общая цель</li>
              </ul>
            </Card>

            <Card padding="lg" className="border-rose-200 bg-rose-50/50" data-id="element-20528">
              <div className="flex items-center mb-4 text-rose-700" data-id="element-20529">
                <Minus className="w-6 h-6 mr-2" data-id="element-20530" />
                <h3 className="text-lg font-bold" data-id="element-20531">В минусе (Пораженный)</h3>
              </div>
              <ul className="space-y-3 text-rose-900 text-sm" data-id="element-20532">
                <li data-id="element-20533">• Частые ссоры и конфликты в браке</li>
                <li data-id="element-20534">• Конкуренция с партнером</li>
                <li data-id="element-20535">• Притяжение агрессивных людей</li>
                <li data-id="element-20536">• Риск разрыва отношений из-за импульсивности</li>
              </ul>
            </Card>
          </div>

          <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6" data-id="element-20537">
            Как проявляется в жизни
          </h2>
          <p data-id="element-20538">
            Люди с Марсом в 7 доме часто рано вступают в брак или делают это
            импульсивно. Им скучно в спокойных, "пресных" отношениях — нужна
            искра, динамика, совместное преодоление препятствий. Если этой
            динамики нет во внешнем мире, они могут бессознательно провоцировать
            конфликты дома, чтобы получить необходимый выброс адреналина.
          </p>

          <div className="bg-amber-50 border-l-4 border-amber-500 p-6 my-8 not-prose rounded-r-xl" data-id="element-20539">
            <div className="flex items-start" data-id="element-20540">
              <Lightbulb className="w-6 h-6 text-amber-600 mr-3 flex-shrink-0 mt-1" data-id="element-20541" />
              <div data-id="element-20542">
                <h4 className="font-bold text-amber-900 mb-2" data-id="element-20543">
                  Совет астролога
                </h4>
                <p className="text-amber-800 text-sm leading-relaxed" data-id="element-20544">
                  Лучший способ гармонизировать Марс в 7 доме — найти с
                  партнером общего "врага" или общую цель. Это может быть
                  совместный бизнес, ремонт, активный спорт (например, теннис
                  или походы). Энергия Марса должна расходоваться вовне, а не
                  друг на друга.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6" data-id="element-20545">
            Частые вопросы
          </h2>
          <div className="not-prose mb-12" data-id="element-20546">
            <Accordion items={faqs} data-id="element-20547" />
          </div>
        </div>

        {/* CTA Section */}
        <Card padding="lg" className="bg-slate-900 text-white border-none text-center mt-12" data-id="element-20548">
          <h3 className="text-2xl font-bold mb-4" data-id="element-20549">
            Узнайте, как Марс работает в вашей карте
          </h3>
          <p className="text-slate-300 mb-8 max-w-xl mx-auto" data-id="element-20550">
            Трактовка одной планеты — это лишь часть картины. Закажите полный
            авто-отчёт, чтобы увидеть, как планеты взаимодействуют друг с другом
            именно у вас.
          </p>
          <Button variant="primary" size="lg" onClick={() => onNavigate('service-natal')} data-id="element-20551">
            Рассчитать натальную карту
          </Button>
        </Card>

        {/* Related */}
        <div className="mt-16" data-id="element-20552">
          <h3 className="text-xl font-bold text-slate-900 mb-6" data-id="element-20553">
            Связанные трактовки
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-20554">
            {['Венера в 7 доме', 'Марс в Овне', 'Управитель 7 дома в 1'].map(item => <Card key={item} hoverable padding="sm" className="flex items-center justify-between cursor-pointer" onClick={() => onNavigate('interpretation-detail')} data-id="element-20555">
                  <span className="font-medium text-slate-700" data-id="element-20556">{item}</span>
                  <ArrowRight className="w-4 h-4 text-slate-400" data-id="element-20557" />
                </Card>)}
          </div>
        </div>
      </div>
    </div>;
}